import React from 'react'
import {ListGuesser} from '@api-platform/admin'
import {Filter, TextInput, TextField} from 'react-admin'
import ListPagination from "../../../components/admin/ListPagination"

import PostBulkActionButtons from "../../../components/admin/PostBulkActionButtons";
import ListActions from "../../../components/admin/Actions";
import {useTranslation} from "react-i18next";

function List(props) {
    const {t} = useTranslation()
    return (
        <ListGuesser
            perPage={30}
            pagination={<ListPagination/>}
            {...props}
            filters={<Filter>
                <TextInput label={t('common.name')} source="name"/>
            </Filter>}
            bulkActionButtons={<PostBulkActionButtons
                //showExportButton={true}
                showDeleteButton={true/*Roles.hasAccess('ClientsEdit')*/}
            />}
            actions={<ListActions
                showNewButton={true/*Roles.hasAccess('ClientsEdit')*/}
                //showExportButton={true}
            />}
        >
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
        </ListGuesser>
    )
}

export default List
